import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'mcg-icon',
  standalone: true,
  imports:[CommonModule],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.css'
})
export class IconComponent {

  /**
   * The name code of the icon.
   */
  public name = input.required<string>();

  /**
   * Alternative text for accessibility (AKA aria label).
   */
  public description = input<string>();

  /**
   * Size of the icon
   */
  public size = input<number>(16);
}
